// type ModuleType = typeof import('./*.svg');

// const allLogos: Record<string, unknown> = import.meta.glob('./*.svg', {
//   eager: false,
// });

import analyticsLogo from './analytics.svg?url';
import docsLogo from './docs.svg?url';
import managerLogo from './manager.svg?url';
import orgLogo from './org.svg?url';
import proStudioLogo from './pro-studio.svg?url';
import projectLogo from './project-created.svg?url';
import contactCenterLogo from './contact-center.svg?url';
import pypeLogo from './pype.svg?url';
import homeLogo from './home.svg?url';
import salesforceLogo from './salesforce.svg?url';
import quiqLogo from './quiq.svg?url';
import fbMessengerLogo from './fb-messenger.svg?url';
import whatsappLogo from './whatsapp.svg?url';
import serviceNowLogo from './service-now.svg?url';
import amazonConnectLogo from './amazon-connect.svg?url';
import genesysLogo from './genesys.svg?url';
import zendeskLogo from './zendesk.svg?url';

export const logos = {
  analytics: analyticsLogo,
  docs: docsLogo,
  manager: managerLogo,
  org: orgLogo,
  proStudio: proStudioLogo,
  project: projectLogo,
  contactCenter: contactCenterLogo,
  pype: pypeLogo,
  home: homeLogo,
  salesforce: salesforceLogo,
  quiq: quiqLogo,
  fbMessenger: fbMessengerLogo,
  whatsapp: whatsappLogo,
  serviceNow: serviceNowLogo,
  amazonConnect: amazonConnectLogo,
  genesys: genesysLogo,
  zendesk: zendeskLogo,
};

// export const logos: Record<string, () => Promise<ModuleType>> = {};

// Object.keys(allLogos).forEach((logo) => {
//   const simpleName = logo
//     .substring(logo.lastIndexOf('/') + 1)
//     .replace('.svg', '') as string;

//   const value: () => Promise<ModuleType> = allLogos[
//     logo
//   ] as () => Promise<ModuleType>;

//   logos[simpleName] = value;
// });
